import koTranslation from "./locales/ko.json";
import enTranslation from "./locales/en.json";

export const generalResources = {
  ko: {
    translation: koTranslation,
  },
  en: {
    translation: enTranslation,
  },
};
